import { useEffect, useRef, useState } from "react";
import axios from "../api/axiosInstance";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";

export default function AdminHospitals() {
  const autoRef = useRef(null);
  const [form, setForm] = useState(null);
  const [hospitals, setHospitals] = useState([]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const loadHospitals = () => {
    axios.get("/admin/hospitals/list/")
      .then(res => setHospitals(res.data))
      .catch(() => {});
  };

  useEffect(loadHospitals, []);

  const addHospital = async () => {
    if (!form) {
      alert("Select hospital from Google dropdown suggestions");
      return;
    }

    try {
      await axios.post("/admin/hospitals/", {
        name: form.name,
        address: form.address,
        lat: Number(form.lat.toFixed(6)),
        lng: Number(form.lng.toFixed(6)),
      });

      setForm(null);
      loadHospitals();
    } catch (err) {
      alert("Failed to add hospital");
    }
  };

  if (!isLoaded) return <p>Loading Maps...</p>;

  return (
    <div>
      <h2>Hospitals</h2>

      <Autocomplete
        onLoad={(auto) => (autoRef.current = auto)}
        onPlaceChanged={() => {
          const place = autoRef.current.getPlace();
          if (!place || !place.geometry) return;

          setForm({
            name: place.name,
            address: place.formatted_address,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          });
        }}
      >
        <input
          style={{ width: "420px", padding: "10px", fontSize: "16px" }}
          placeholder="Search hospital..."
        />
      </Autocomplete>

      {form && <p style={{ color: "green" }}>✓ Selected: {form.name}</p>}

      <button onClick={addHospital}>Add Hospital</button>

      <ul>
        {hospitals.map((h) => (
          <li key={h.id}>
            {h.name} – {h.address}
          </li>
        ))}
      </ul>
    </div>
  );
}